import { useState } from 'react';
import { useIsFetching } from '@tanstack/react-query';
import { tariffSummaryQueries } from './Inventory/queries/tariffSummaryQueries';
import { SelectedTariffContext } from 'src/products/tariffSummary/SelectedTariffContext';

export const SelectedTariffContextProvider = ({ children }: { children?: React.ReactNode }) => {
  const [selectedTariffId, setSelectedTariffId] = useState('');

  const isTariffTableDataFetching = useIsFetching({
    queryKey: tariffSummaryQueries.listAll(),
  });

  if (isTariffTableDataFetching && selectedTariffId !== '') {
    setSelectedTariffId('');
  }

  const toggleSelectTariffId = (tariffId: string) => {
    setSelectedTariffId((prev) => (prev === tariffId ? '' : tariffId));
  };

  return (
    <SelectedTariffContext value={{ selectedTariffId, toggleSelectTariffId }}>
      {children}
    </SelectedTariffContext>
  );
};
